import { PropsWithChildren } from "react"
import { GrowthBookProvider as Provider } from "@growthbook/growthbook-react"

import { growthBook } from "utils/infrastructure/growthBook/growthBook"

export function GrowthBookProvider({ children }: PropsWithChildren<void>) {
    return <Provider growthbook={growthBook}>{children}</Provider>
}
